import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconBookmarkFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#FFC64D",
		d: "M11.333 2H4.666c-.733 0-1.326.6-1.326 1.333L3.333 14 8 12l4.666 2V3.333c0-.733-.6-1.333-1.333-1.333z"
	})
});
export default SvgIconBookmarkFill;
